export default __webpack_public_path__ + "static/media/icon-6.9a80b701.png";